<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="8">
                    <el-button-group>
                        <el-button type="info" icon="el-icon-refresh" @click="refresh()">刷新</el-button>
                        <el-button type="info" icon="el-icon-circle-plus" @click="part()">分配</el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型编号" v-model="input6" class="input-with-select" clearable>
                    </el-input>
                </el-col>
            </el-row>
            <el-row class="locationCode">
                <el-col :span="24">
                    <el-table
                        v-loading ="loading"
                        element-loading-text = '加载中'
                        :data = "tableData3 .filter(data => !input6 || data.typeCode.includes(input6))"
                        max-height="340"
                        border
                        style="width:100%"
                        :summary-method="getSummaries"
                        show-summary
                    >
                        <el-table-column
                            label="类型编号"
                            prop="typeCode"
                            width="120"
                            header-align="center"
                            >
                        <template slot-scope="scope">{{ scope.row.typeCode }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="description"
                            label="类型名称"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalGeneratedQty"
                            label="已生成"
                            header-align="center"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="qty"
                            :label="label3"
                            header-align="center"
                            align="right"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .el-table__footer-wrapper td{
        text-align: right !important;
    }
    #location{
        .locationCode{
            margin: 20px 0;
        }
    }
</style>
<script>
import requestMixin from '@/mixins/request'
import common from '@/mixins/common'    
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            loading:false,
            input6:"",
            
        }
    },
    props:{
        label3:{
            type:String,
            default:''
        },
        tableData3:{
            type:Array,
            default:()=>{}
        }
    },
    mounted(){
        
    },
    methods:{
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item =>{
                    return Number(item[column.property].toString().replace(/,/g, ""))
                    
                    });
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    // sums[index]
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
                return sums;
        },
        //传递事件
        refresh(){
            this.$emit('refresh')
        },
        //分配
        part(){
           this.$emit('clickMag')
        },

    }
}
</script>
